import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2Nzg2OTEwNzg0NywiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA2ODI2In0.41SPX5nTwM4JwnDQPSX0ps_lpp8fc8VI0ifaT2tFv6Op-7ukbKWNfhUPZUwAn-uy2DEmC2I75Y_TLKEWBW7NiQ`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
